import { perAcreUnitKeyByHarvest } from '@cibo/landmanager/src/features/DetailEditing/CashCrop/types'
import {
  ClearableNumberFieldProps,
  ClearableNumberInput,
} from '@cibo/ui/src/components/Form/Uniforms/NumberField'
import { assocPath } from 'ramda'
import { useTranslation } from 'react-i18next'
import { connectField, useForm } from 'uniforms'

export const YieldPerAcreInput = (props: ClearableNumberFieldProps) => {
  const { t } = useTranslation('@cibo/landmanager/CashCropEditor')

  const { model } = useForm<{ value: { harvestType?: string } }>()

  const harvestType = model?.value.harvestType as string | undefined

  const yieldProps = assocPath<ClearableNumberFieldProps, ClearableNumberFieldProps>(
    ['ui-params', 'units'],
    t(perAcreUnitKeyByHarvest(harvestType))
  )(props)

  return <ClearableNumberInput {...yieldProps} />
}

export const YieldPerAcreField = connectField(YieldPerAcreInput)
